import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";

import "./index.scss";

const ReactionChip = ({
    emoji,
    count,
    active = false,
    disabled = false,
    onToggle,
    className = "",
}) => {
    const handleClick = () => {
        if (disabled || !onToggle) {
            return;
        }
        onToggle();
    };

    return (
        <button
            type="button"
            className={classNames("reaction-chip", className, {
                "reaction-chip--active": active,
                "reaction-chip--disabled": disabled,
            })}
            onClick={handleClick}
            disabled={disabled}
            aria-pressed={active}
        >
            <span className="reaction-chip__emoji" aria-hidden="true">{emoji}</span>
            <span className="reaction-chip__count">{count}</span>
        </button>
    );
};

ReactionChip.propTypes = {
    emoji: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onToggle: PropTypes.func,
    className: PropTypes.string,
};

ReactionChip.defaultProps = {
    count: 0,
    active: false,
    disabled: false,
    onToggle: null,
    className: "",
};

export default ReactionChip;
